import TrailerSelectorDialog from "../../../../../../dialogs/selectors/TrailerSelectorDialog";

const EditorTrailerDialogs = ({
  showTrailerSelector,
  setShowTrailerSelector,
  handleOnConfirmTrailer,
}) => {
  return (
    <TrailerSelectorDialog
      title="Pilih Trailer"
      visible={showTrailerSelector}
      onHide={() => setShowTrailerSelector(false)}
      onConfirm={handleOnConfirmTrailer}
    />
  );
};

export default EditorTrailerDialogs;
